export default __webpack_public_path__ + "static/media/order-white.4633bc8e.svg";